import dwfResourcesImg from "../assets/images/dwfresources.png";
import walkforwenjackImg from "../assets/images/walkforwenjack.png";
import newResourcesImg from "../assets/images/newresources.png";
import allyshipreconciliationdecolonizationImg from "../assets/images/allyshipreconciliationdecolonization.png";
import datesofsignificanceImg from "../assets/images/datesofsignificance.png";
import foodsovereigntyImg from "../assets/images/foodsovereignty.png";
import indigenouslanguagesImg from "../assets/images/indigenouslanguages.png";
import landacknowledgementsImg from "../assets/images/landacknowledgements.png";
import enfrancaisImg from "../assets/images/francais.png";
import landclaimsImg from "../assets/images/landclaims.png";
import mmiwgsImg from "../assets/images/mmiwg2s.png";
import theindianactImg from "../assets/images/theindianact.png";
import treatiesImg from "../assets/images/treaties.png";
import twoslgbtqiaImg from "../assets/images/lgbtqia2s.png";
import waterImg from "../assets/images/water.png";
import digitaltoolkitImg from "../assets/images/legacyschoolstoolkit.png";


export const CollectionsResourceTiles = [
  { 
    title: "Created By DWF",
    slug: "created-by-dwf",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrljaZYooaAbgBOe",
    imagesrc: dwfResourcesImg,
  },
  { 
    title: "Walk for Wenjack",
    slug: "walk-for-wenjack",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrPd5KSjgoxmshT0",
    imagesrc: walkforwenjackImg,
  },
  { 
    title: "New Resources",
    slug: "new-resources",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrtm2M1Xt8TNNX5v",
    imagesrc: newResourcesImg,
  },
  { 
    title: "Allyship, Reconciliation & Decolonization ",
    slug: "allyship-reconciliation-decolonization",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrPuQ9UiZrj3HBE3",
    imagesrc: allyshipreconciliationdecolonizationImg,
  },
  { 
    title: "Dates of Significance",
    slug: "dates-of-significance",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shr6mFBLAsmncrG6v",
    imagesrc: datesofsignificanceImg,
  },
  { 
    title: "En Français",
    slug: "en-francais",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shr18svminI9WRAY8",
    imagesrc: enfrancaisImg,
  },
  { 
    title: "Food Sovereignty",
    slug: "food-sovereignty",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shr3Q2Ba3vg4Sq63y",
    imagesrc: foodsovereigntyImg,
  },
  { 
    title: "Indigenous Languages",
    slug: "indigenous-languages",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrxXb4xWgwKQP9Vb",
    imagesrc: indigenouslanguagesImg,
  },
  { 
    title: "Land Acknowledgements",
    slug: "land-acknowledgements",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrHPtOzjmlov42BH",
    imagesrc: landacknowledgementsImg,
  },
  { 
    title: "Land Claims",
    slug: "land-claims",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrgBIJLngmCIcDvb",
    imagesrc: landclaimsImg,
  },
  { 
    title: "MMIWG2S+",
    slug: "mmiwg2s",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrmdUUIfqV2URL6H",
    imagesrc: mmiwgsImg,
  },
  { 
    title: "The Indian Act",
    slug: "the-indian-act",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrUMq7RXmYKmOyoj",
    imagesrc: theindianactImg,
  },
  { 
    title: "Treaties",
    slug: "treaties",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shr7ccLxQIM4BgFYy",
    imagesrc: treatiesImg,
  },
  { 
    title: "2SLGBTQIA+",
    slug: "2slgbtqia",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrNFI2Q9YCE8Rhw2",
    imagesrc: twoslgbtqiaImg,
  },
  { 
    title: "Water",
    slug: "water",
    url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shrR6C0JmEG2JZhmV",
    imagesrc: waterImg,
  },
  //{ 
    //title: "Digital Toolkit",
    //slug: "digital-toolkit",
    //url: "https://airtable.com/embed/apprWesJGBmsmfsWx/shr4jnoG49kyRvW5f",
    //imagesrc: digitaltoolkitImg,
  //},


] as const;